import * as React from "react";
import { Button, Classes, InputGroup, Intent, Tooltip, IconNames, } from "../externals";
import "./FileFilter.scss";
const FileFilter = ({ filterString, onFilterClean, onInputChange, }) => {
    const cleanFilterButton = (React.createElement(Tooltip, { content: "Clean filters" },
        React.createElement(Button, { className: `${Classes.MINIMAL} ${Classes.iconClass(IconNames.SMALL_CROSS)}`, intent: Intent.DANGER, onClick: onFilterClean })));
    return (React.createElement("div", { className: "filefilter-field" },
        React.createElement(InputGroup, { disabled: false, leftIcon: "filter", onChange: onInputChange, rightElement: cleanFilterButton, value: filterString })));
};
export default FileFilter;
//# sourceMappingURL=FileFilter.js.map